import React from "react";
import CloseIcon from "@src/assets/svg/close-icon.svg";
import { Title } from "@components/atoms/title/title";
import styles from "./unsaved-structure-modal.module.scss";
import { HintTitle } from "@components/atoms/hint-title/hint-title";
import { Button } from "@components/atoms/buttons/button/button";
import { ButtonWithLoader } from "@src/components/atoms/buttons/button-with-loader/button-with-loader";
import { GlassyModal } from "../glassy-modal/glassy-modal";
import { GlassyModalHeader } from "@src/components/molecules/glassy-modal-header/glassy-modal-header";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import { Spacer16 } from "@src/components/atoms/spacer-16/spacer-16";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { useI18N } from "@src/language/language-context";
import { useUnsavedStructureModalHook } from "./use-unsaved-structure-modal-hook";

const cssClassName = "unsaved-modal";

export const UnsavedStructureModal = () => {
  const { saveStructureLoading, closeModal, saveAndExit, exitWithoutSaving } =
    useUnsavedStructureModalHook();
  const i18n = useI18N();

  const texts = {
    subTitle: i18n("modules.unsavedStructureModal.subTitle"),
    title: i18n("modules.unsavedStructureModal.title"),
    descriptionFirstLine: i18n(
      "modules.unsavedStructureModal.descriptionFirstLine",
    ),
    descriptionSecondLine: i18n(
      "modules.unsavedStructureModal.descriptionSecondLine",
    ),
    exitWithoutSavingButton: i18n(
      "modules.unsavedStructureModal.exitWithoutSavingButton",
    ),
    saveStructureButtonText: i18n(
      "modules.unsavedStructureModal.saveStructureButtonText",
    ),
  };

  return (
    <GlassyModal>
      <div className={styles[cssClassName]}>
        <GlassyModalHeader
          title={texts.subTitle}
          rightIcon={CloseIcon}
          rightIconFunction={closeModal}
        />
        <HorizontalSeparator verticalMargin={16} />
        <Spacer16 />
        <div className={styles[`${cssClassName}__modal-content`]}>
          <Title text={texts.title} />
          <div className={styles[`${cssClassName}__hint-content`]}>
            <HintTitle text={texts.descriptionFirstLine} />
            <HintTitle text={texts.descriptionSecondLine} />
          </div>
          <FlexRowContainer>
            <ButtonWithLoader
              fun={saveAndExit}
              text={texts.saveStructureButtonText}
              loading={saveStructureLoading}
            />
            <Button
              variant={["secondary", "alert"]}
              fun={exitWithoutSaving}
              text={texts.exitWithoutSavingButton}
            />
          </FlexRowContainer>
        </div>
      </div>
    </GlassyModal>
  );
};
